import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../styles/app.css';
import AppHeader from '../../components/app-header';

const AppWrapper = () => {
  return (
    <div
      data-testid="app-container"
      className="bg-agnt-background w-full h-full"
    >
      <AppHeader />
      <main className="mx-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AppWrapper;
